// @flow
import * as React from 'react';
import { Box, Flex } from '@locus-taxy/neo-ui';

import ObjectPropertiesView from './ObjectPropertiesView';

import type { ObjectArray, ObjectArrayMetadata } from './types';

type Props = {
    objectArray: ObjectArray,
    i18n: $FixMe,
    metadata: ObjectArrayMetadata,
    onEdit: (data: ObjectArray) => void
};

const ModalContent = ({
    objectArray,
    i18n,
    metadata,
    onEdit
}: Props): React.Node => (
    <Box m={4}>
        <Flex flexWrap="wrap">
            {objectArray.map(properties => {
                const { key } = properties;

                return (
                    <Box width="412px" key={key} mb={4} ml={4}>
                        <ObjectPropertiesView
                            properties={properties}
                            i18n={i18n}
                            metadata={metadata}
                            onEdit={onEdit}
                        />
                    </Box>
                );
            })}
        </Flex>
    </Box>
);

export default ModalContent;
